import { Box, Typography } from "@mui/material"
import { CheckCircleOutlined, ErrorOutlined, HourglassEmptyOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"

import { UploadRowStatus } from "./types"

import type { UploadRowProgress } from "@/hooks/useMultiFileUpload"

const UPLOAD_ROW_STATUS_TO_LABEL: Record<UploadRowStatus, string> = {
  [UploadRowStatus.Pending]: "Pending",
  [UploadRowStatus.Uploading]: "Uploading…",
  [UploadRowStatus.Uploaded]: "Uploaded",
  [UploadRowStatus.Failed]: "Failed",
}

interface StatusIndicatorProps {
  status: UploadRowStatus
  progress?: UploadRowProgress
}

export const StatusIndicator = ({ status, progress }: StatusIndicatorProps): ReactElement => {
  const iconClassName = "size-4"
  const statusToIcon: Record<UploadRowStatus, ReactElement> = {
    [UploadRowStatus.Pending]: <HourglassEmptyOutlined className={`${iconClassName} text-gray-400`} />,
    [UploadRowStatus.Uploading]: <HourglassEmptyOutlined className={`${iconClassName} text-primary`} />,
    [UploadRowStatus.Uploaded]: <CheckCircleOutlined className={`${iconClassName} text-success-500`} />,
    [UploadRowStatus.Failed]: <ErrorOutlined className={`${iconClassName} text-error-400`} />,
  }
  const showFanOutCount = progress && progress.total > 1 && status === UploadRowStatus.Uploading
  const label = showFanOutCount
    ? `Uploading (${progress.completed} of ${progress.total})`
    : UPLOAD_ROW_STATUS_TO_LABEL[status]

  return (
    <Box className='flex shrink-0 items-center gap-1'>
      {statusToIcon[status]}
      <Typography variant='caption' className='text-gray-600'>
        {label}
      </Typography>
    </Box>
  )
}
